module.exports = {
  TOKEN_EXTENSION_SAFETY_MARGIN_SECONDS: 120
};
